/**
 * Section 4 — report configuration. Column toggles driven by the registry
 * entry; finance columns are already stripped for users without finance
 * access.
 */

function ColumnsStep({ wiz }) {
  const { visibleColumns, enabledColumns, toggleColumn, columnsOk } = wiz;

  return (
    <div className="prw-step-panel">
      <p className="prw-step-hint">בחרו אילו נתונים יוצגו בדוח</p>

      <div className="prw-toggle-list">
        {visibleColumns.map((col) => (
          <div key={col.key} className="prw-toggle-row">
            <span className="prw-toggle-label">{col.label}</span>
            <label className="prw-toggle">
              <input
                type="checkbox"
                checked={!!enabledColumns[col.key]}
                onChange={() => toggleColumn(col.key)}
                aria-label={col.label}
              />
              <span className="prw-toggle-slider"></span>
            </label>
          </div>
        ))}
      </div>

      {!columnsOk && (
        <div className="prw-field-error">יש לבחור לפחות עמודה אחת</div>
      )}
    </div>
  );
}

export default ColumnsStep;
